module.exports = __webpack_public_path__ + "assets/img/news3.4.4466e5e7.png";